import React from "react";
import { Grid, TextField, Typography } from "@mui/material";
import { FormikProps } from "formik";
import { styles } from "../../../pages/Storage/shared/styles";
import { InitialValues } from "../../../pages/Storage/models/types";
import TextFieldCustom from "../../TextFieldCustom/TextFieldCustom";

interface DischargeFieldsProps {
  formik: FormikProps<InitialValues>;
  isViewing: boolean;
  setUnitPrice: (value: string) => void;
}

export const DischargeFields: React.FC<DischargeFieldsProps> = ({
  formik,
  isViewing,
  setUnitPrice,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={8}>
        <Typography
          color="shadesOfDark.dark"
          sx={{ mb: 0.5, fontWeight: 700, fontFamily: "Open Sans" }}
        >
          Nº da NF
        </Typography>
        <TextField
          variant="outlined"
          size="small"
          placeholder="Insira"
          value={formik.values.orderNumber}
          onChange={({ target: { value } }) => {
            formik.setFieldValue("orderNumber", value);
          }}
          disabled={isViewing}
          sx={styles.textField}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography
          color="shadesOfDark.dark"
          sx={{ mb: 0.5, fontWeight: 700, fontFamily: "Open Sans" }}
        >
          Série da NF
        </Typography>
        <TextField
          variant="outlined"
          size="small"
          placeholder="Insira"
          value={formik.values.orderSeries}
          onChange={({ target: { value } }) => {
            formik.setFieldValue("orderSeries", value);
          }}
          disabled={isViewing}
          sx={styles.textField}
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldCustom
          label="Preço Unitário"
          placeholder="R$ 0,000000"
          value={formik.values.unitPrice}
          onChange={({ target: { value } }) => setUnitPrice(value)}
          mask="currency"
          maskDecimals={6}
          disabled={isViewing}
          sx={styles.textField}
        />
      </Grid>
    </Grid>
  );
};
